'use client'

import { ACCOUNT_DRAWER_HANDLE } from '@/feature/account/services/account.constants'
import { toDashboard } from '@/feature/dashboard/services/dashboard.routing'
import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { pushToGtmDataLayer } from '@/lib/tracking/services/tracking.gtm'
import { useCloseDrawer } from '@/ui/drawer/drawer/Drawer.client'
import { Icon } from '@/ui/icons/icon/Icon'
import { NavigationCard } from '@/ui/cards/navigation-card/NavigationCard.client'

export function NavigationHubDashboardTile() {
  const { t } = useTranslation(['accountDrawer'])
  const closeAccountDrawer = useCloseDrawer(ACCOUNT_DRAWER_HANDLE)

  return (
    <NavigationCard
      className="grow basis-[calc(50%_-_0.25rem)]"
      href={toDashboard}
      icon={<Icon.LayoutGrid />}
      size="lg"
      onPress={() => {
        closeAccountDrawer()
        pushToGtmDataLayer({
          event: 'gaEvent',
          eventCategory: 'layer mon compte',
          eventAction: 'clic section',
          eventLabel: 'tableau de bord',
        })
      }}
    >
      {t('accountDrawer:dashboard')}
    </NavigationCard>
  )
}
